import React from 'react';
import { ArrowRightIcon, GemIcon, HammerIcon, LayoutGridIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { CONTACT, WHY_IMAGE } from '../data/media';
import { Mascot } from './Mascot';
import { Reveal } from './Reveal';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  craft: HammerIcon,
  diverse: LayoutGridIcon,
  materials: GemIcon,
  warranty: ShieldCheckIcon
};
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="w-full bg-cream py-16 lg:py-20" data-id="element-386" data-mp="l80qt7cd0gnc">
      <div className="mx-auto grid max-w-shell grid-cols-1 items-center gap-10 px-4 sm:px-6 lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] lg:gap-16 lg:px-8" data-id="element-387" data-mp="77zrvxfnnjai">
        <Reveal className="relative" data-id="element-388" data-mp="bactc9ndcv1h">
          <img src={WHY_IMAGE} alt="Pollo Construction crew installing a shingle roof, finishing drywall, and setting a granite countertop" className="aspect-[4/5] w-full rounded object-cover shadow-lift" data-id="element-389" data-mp="21kphw42wk8cm" />
          <div className="absolute -bottom-5 left-5 right-5 flex items-center gap-3 rounded bg-ink px-5 py-4 sm:left-8 sm:right-auto" data-id="element-390" data-mp="1ncais2m9yqxv">
            <span className="font-display text-3xl font-extrabold text-brand-500" data-id="element-391" data-mp="1x4q1511hhhja">20+</span>
            <span className="text-xs font-bold uppercase leading-tight tracking-wider text-white/80" data-id="element-392" data-mp="1s4txj2wp7s49">
              Years, All Home Services
              <span className="block text-white/45" data-id="element-393" data-mp="14gay7cvmmpob">{CONTACT.license}</span>
            </span>
          </div>
        </Reveal>

        <div className="pt-8 lg:pt-0" data-id="element-394" data-mp="zj2f9a2nmhm0">
          <Reveal data-id="element-395" data-mp="1ee8m1z9kqkge">
            <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-396" data-mp="1eeqf6n0xwik3">
              {t.why.eyebrow}
            </p>
            <h2 className="font-display text-3xl font-extrabold leading-[1.1] text-ink sm:text-4xl lg:text-[42px]" data-id="element-397" data-mp="2pt431rvp0y04">
              {t.why.title}
            </h2>
            <div className="mt-5 flex items-start gap-4" data-id="element-398" data-mp="2ktre91l9hguw">
              <Mascot size={52} tone="light" animate className="mt-1" data-id="element-399" data-mp="2ry0mrw1x5vi4" />
              <p className="text-base leading-relaxed text-[#5B5B5B]" data-id="element-400" data-mp="2wwbvg3gh9zyr">{t.why.intro}</p>
            </div>
            <p className="mt-4 text-base leading-relaxed text-[#5B5B5B]" data-id="element-401" data-mp="31vf0vp0de879">{t.why.local}</p>
            <p className="mt-6 border-l-4 border-brand-500 bg-white py-4 pl-5 pr-4 shadow-card" data-id="element-402" data-mp="36uhxqm675845">
              <span className="block font-display text-base font-extrabold uppercase tracking-wide text-ink" data-id="element-403" data-mp="36s5fs90fuxr3">
                {t.why.highlight}
              </span>
              <span className="mt-1 block text-sm text-[#5B5B5B]" data-id="element-404" data-mp="2e6ca9rnrd50m">{t.why.highlightBody}</span>
            </p>
          </Reveal>

          <ul className="mt-9 grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-405" data-mp="2j32pkcrqnwkz">
            {t.why.points.map((point, index) => {
            const Icon = icons[point.id] ?? GemIcon;
            return <Reveal as="li" key={point.id} delay={index * 0.05} data-id="element-406" data-mp="1qefa4xto81fc" data-mpi={index}>
                  <div className="flex gap-4" data-id="element-407" data-mp="1vdrvfe4w90ft">
                    <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded bg-white shadow-card" data-id="element-408" data-mp="cjyj1oj88ih5">
                      <Icon className="h-5 w-5 text-brand-500" aria-hidden="true" data-id="element-409" data-mp="8jofeiiwq45g" />
                    </span>
                    <div data-id="element-410" data-mp="3i8qughitfib">
                      <h3 className="font-display text-base font-extrabold uppercase tracking-wide text-ink" data-id="element-411" data-mp="3lmuds1x7urc">
                        {point.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-[#5B5B5B]" data-id="element-412" data-mp="3psbd50c8wp30">
                        {point.description}
                      </p>
                    </div>
                  </div>
                </Reveal>;
          })}
          </ul>

          <Reveal delay={0.1} data-id="element-413" data-mp="3c04wze93ei3k">
            <a href="#contact" className="group mt-10 inline-flex items-center gap-2 rounded bg-ink px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors duration-200 ease-smooth hover:bg-brand-500 hover:text-ink" data-id="element-414" data-mp="3c0wvoxxzkvy2">
              {t.why.cta}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-415" data-mp="160dntioydqvq" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>;
}